import { PulseItem } from "./PulseItem";

interface ISkeletonProps {
  isMinorTablet: boolean;
}
const Skeleton = ({ isMinorTablet }: ISkeletonProps) => {
  return (
    <div className="animate-pulse flex space-x-2 mt-12">
      <div
        className={`rounded-sm ${
          isMinorTablet ? "h-12 w-12" : "h-48 w-48"
        } bg-mid-grey-20`}
      ></div>
      <div className="flex-1 ">
        <div
          className={` ${
            isMinorTablet ? "h-24" : "h-28"
          } bg-mid-grey-20 rounded-sm`}
        ></div>
        <div className="h-8 bg-mid-grey-20 rounded-lg mt-8"></div>
        <div className="h-8 bg-mid-grey-20 rounded-lg mt-4"></div>
        <div className="space-y-3 mt-8">
          {[...Array(5)].map((_, index) => (
            <PulseItem key={index + 12} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
